package com.schoolconnect.app.feature.reports

data class UsageAdoptionRowUi(
    val role: String,
    val totalUsers: Int,
    val activeUsers: Int,
    val adoptedUsers: Int,
    val averageLoginsPerUser: Double,
    val neverLoggedIn: Int
) {
    val adoptionRate: Double?
        get() = if (totalUsers == 0) null else adoptedUsers * 100.0 / totalUsers
}

data class ReportsUiState(
    // Fixed to the supplied sample month while this screen is running on demo data.
    val fromDate: String = "01 Oct 2026",
    val toDate: String = "31 Oct 2026",
    val role: String = "All Roles",
    val metric: String = "None",
    val operator: String = "Less than",
    val firstValue: String = "80",
    val secondValue: String = "90",
    val appliedFromDate: String = fromDate,
    val appliedToDate: String = toDate,
    val appliedRole: String = role,
    val appliedMetric: String = metric,
    val appliedOperator: String = operator,
    val appliedFirstValue: String = firstValue,
    val appliedSecondValue: String = secondValue,
    val validationMessage: String = "",
    val feedbackMessage: String = "",
    val showFullReport: Boolean = false,
    val pageIndex: Int = 0,
    val pageSize: Int = 20,
    val rowsPerPageExpanded: Boolean = false,
    val totalCount: Int = 0,
    val isLoading: Boolean = false
)

sealed interface ReportsUiEvent {
    data class FromDateChanged(val value: String) : ReportsUiEvent
    data class ToDateChanged(val value: String) : ReportsUiEvent
    data class RoleChanged(val value: String) : ReportsUiEvent
    data class MetricChanged(val value: String) : ReportsUiEvent
    data class OperatorChanged(val value: String) : ReportsUiEvent
    data class FirstValueChanged(val value: String) : ReportsUiEvent
    data class SecondValueChanged(val value: String) : ReportsUiEvent
    data object RunReport : ReportsUiEvent
    data object Reset : ReportsUiEvent
    data object ViewFullReport : ReportsUiEvent
    data object ShowPreview : ReportsUiEvent
    data class ExportSelected(val format: String) : ReportsUiEvent
    data class PageChanged(val pageIndex: Int) : ReportsUiEvent
    data class PageSizeChanged(val pageSize: Int) : ReportsUiEvent
    data object ToggleRowsPerPage : ReportsUiEvent
    data object DismissRowsPerPage : ReportsUiEvent
}
